import Logger from '@/logger'

import CONTEXT_TYPES from './CONTEXT_TYPES'
import Context from './context'

/**
 * Defined structure of a guest context.
 * @export GuestContext
 * @class GuestContext
 */
export default class GuestContext extends Context {

    /**
     * Creates an instance of GuestContext.
     * @param {string} id The identifier to create a named context.
     * @memberof GuestContext
     */
    constructor(id = 'TEMP-GUEST') {
        super(CONTEXT_TYPES.guest, 'unused')

        this.id = id ? id : 'TEMP-GUEST'
    }

    /**
     * Returns the object type from raw stored JSON data.
     * @param {?Object} data The stored data.
     * @returns {GuestContext|never}
     * @throws {TypeError} The provided context data was not a guest context.
     * @memberof GuestContext
     */
    static fromStoreJson(data = null) {
        if (data == null)
            return new GuestContext()

        if (data.type === CONTEXT_TYPES.guest)
            return new GuestContext(data.id)

        Logger.logObject(data, 'Attempted to create an invalid guest context.', 'Context')
        throw new TypeError('The provided context data was not a guest context.')
    }
}
